import SearchHistoryList from './SearchHistoryList';

export default SearchHistoryList;
